"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.anyValuesChanged = exports.getRefs = void 0;
const react_1 = __importStar(require("react"));
const react_final_form_1 = require("react-final-form");
const gen5_datamapping_lib_1 = require("@terragotech/gen5-datamapping-lib");
const FormContexts_1 = require("../Contexts/FormContexts");
const lodash_1 = __importDefault(require("lodash"));
const handleInput = (input, map, nodes, ret) => {
    if (input) {
        let items = [];
        if (!Array.isArray(input)) {
            items = [input];
        }
        else {
            items = input;
        }
        for (const node of items) {
            if (node && typeof node === 'object') {
                if (node['sourceObject'] && map.nodes && nodes.includes(map.nodes[node['sourceObject']].type || '')) {
                    if (ret[map.nodes[node['sourceObject']].type || ''] &&
                        !ret[map.nodes[node['sourceObject']].type || ''].includes(node['sourcePath'])) {
                        ret[map.nodes[node['sourceObject']].type || ''].push(node['sourcePath'].replace(/^\$\./, ''));
                    }
                    else if (!ret[map.nodes[node['sourceObject']].type || '']) {
                        ret[map.nodes[node['sourceObject']].type || ''] = [node['sourcePath'].replace(/^\$\./, '')];
                    }
                }
                else {
                    Object.keys(node).forEach((k) => {
                        handleInput(node[k], map, nodes, ret);
                    });
                }
            }
        }
    }
};
const getRefs = (map, nodes) => {
    const ret = {};
    if (map.nodes) {
        Object.keys(map.nodes).forEach((key) => {
            if (map.nodes) {
                const inputs = map.nodes[key].inputs || {};
                Object.keys(inputs).forEach((k) => {
                    handleInput(inputs[k], map, nodes, ret);
                });
            }
        });
    }
    return ret;
};
exports.getRefs = getRefs;
const anyValuesChanged = (refs, previous, current) => {
    return (refs &&
        lodash_1.default.some(refs, (val) => {
            return !lodash_1.default.isEqual(lodash_1.default.get(previous, val), lodash_1.default.get(current, val));
        }));
};
exports.anyValuesChanged = anyValuesChanged;
/**
 * This component builds a datamapper, which is evaluated to determine the visibility of the child component. Because of the nature of the data mapper hooks, this component has to grab the
 *   form values whether or not the given component even has a condtional definition. As such, consider always using CondtionalOptimizer as it can skip this component
 * @param conditonalMap The data map which defines whether or not to display the chilc component
 */
const ConditionalChildren = (props) => {
    const { conditionalMap, children, refs } = props;
    const formState = react_final_form_1.useFormState({ subscription: { values: true } }); // get the current form state to pass to the data mapper, only when values change
    const formDataMapping = FormContexts_1.useFormDataMappingSources(); // get any supplemental state to pass to data mapper
    const [hidden, setHidden] = react_1.useState(true); // default to hidden
    const { functionDefinitions } = FormContexts_1.useControlProvider();
    const [previousState, setPreviousState] = react_1.useState(undefined);
    const [previousValue, setPreviousValue] = react_1.useState(undefined);
    //calculate the conditional in the background since it's promise based now
    react_1.useEffect(() => {
        var _a, _b, _c, _d;
        if (conditionalMap) {
            const parts = (((_b = (_a = children) === null || _a === void 0 ? void 0 : _a.props) === null || _b === void 0 ? void 0 : _b.controlPath) || '').split('.');
            const t = parts.map((part, idx) => {
                let target = formState.values;
                let name = '';
                for (let i = 0; i < idx; i++) {
                    target = lodash_1.default.get(target, parts[i]);
                    name += parts[i].replace(/\[\d+\]/, '') + '.';
                }
                target = target ? lodash_1.default.get(target, part) : undefined;
                name += part.replace(/\[\d+\]/, '');
                return { [name]: target };
            });
            let formValue = { value: lodash_1.default.get(formState.values, ((_d = (_c = children) === null || _c === void 0 ? void 0 : _c.props) === null || _d === void 0 ? void 0 : _d.controlPath) || '') };
            for (let i = 0; i < t.length; i++) {
                formValue = Object.assign(Object.assign({}, formValue), t[i]);
            }
            if (refs && previousState) {
                if (!exports.anyValuesChanged(refs['FORMVALUE'], previousValue, formValue) &&
                    !exports.anyValuesChanged(refs['FORM'], previousState, formState.values)) {
                    return;
                }
            }
            setPreviousState(lodash_1.default.cloneDeep(formState.values));
            setPreviousValue(lodash_1.default.cloneDeep(formValue));
            gen5_datamapping_lib_1.mapScenarios.FORM_FIELD_CONDITIONAL.evaluate(conditionalMap, Object.assign(Object.assign({}, formDataMapping.accessors), { FORM: () => {
                    return formState.values;
                }, FORMVALUE: () => formValue }), functionDefinitions).then((output) => {
                // This equality is weird, because we want them to be opposite, so if they're equal, we update
                if (hidden === output.isVisible) {
                    setHidden(!output.isVisible);
                }
            });
        }
    }, [
        conditionalMap,
        formDataMapping.accessors,
        formState.values,
        hidden,
        functionDefinitions,
        children,
        previousState,
        previousValue,
        refs,
    ]);
    if (!conditionalMap || !hidden) {
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    }
    else {
        return null;
    }
};
exports.default = ConditionalChildren;
